import React, { Fragment, PureComponent } from 'react';

import FORMAT_TYPES from 'constants/formatTypes';
import INCREMENT_TYPES from 'constants/incrementTypes';
import SORT_TYPES from 'constants/sortTypes';

import { createList } from 'utils/common';
import { toNumber } from 'utils/number';

import ActionBar from 'components/ActionBar';
import Button from 'components/Button';
import Select from 'components/Select';

class ActionBarContainer extends PureComponent {
  render() {
    const specificityList = createList(5, 50);

    return (
      <ActionBar>
        {({ settings, onOrder, onSettingsChange }) => (
          <Fragment>
            <Select
              label="Rainbow Format"
              onChange={({ target }) => {
                onSettingsChange({
                  ...settings,
                  format: target.value,
                });
              }}
              options={FORMAT_TYPES}
              value={settings.format}
            />
            <Select
              label="Sorting Type"
              onChange={({ target }) => {
                onSettingsChange({
                  ...settings,
                  sort: target.value,
                });
              }}
              options={SORT_TYPES}
              value={settings.sort}
            />
            <Select
              label="Increment Type"
              onChange={({ target }) => {
                onSettingsChange({
                  ...settings,
                  incrementType: target.value,
                });
              }}
              options={INCREMENT_TYPES}
              value={settings.incrementType}
            />
            {settings.incrementType === 'blockCount' && (
              <Select
                label="Blocks Count"
                onChange={({ target }) => {
                  onSettingsChange({
                    ...settings,
                    specificity: toNumber(target.value),
                  });
                }}
                options={specificityList}
                value={settings.specificity}
              />
            )}
            {settings.format === 'columns' && (
              <Select
                label="Allow Hover Actions"
                onChange={({ target }) => {
                  onSettingsChange({
                    ...settings,
                    allowActions: target.value === 'true',
                  });
                }}
                options={[{ label: 'Yes', value: true }, { label: 'No', value: false }]}
                value={settings.allowActions}
              />
            )}
            {settings.sort === 'paydownOrder' && (
              <div className="hidden--mobile" style={{ display: 'flex', flexFlow: 'column nowrap' }}>
                <Button dark style={{ flex: '1 1 auto' }} onClick={onOrder}>
                  Reorder Debts
                </Button>
              </div>
            )}
          </Fragment>
        )}
      </ActionBar>
    );
  }
}

export default ActionBarContainer;



// WEBPACK FOOTER //
// ./src/components/DebtRainbow/DebtActions.js